import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const NotificationsSelected = (props: SvgProps) => {
  return (
    <Svg width='23' height='25' viewBox='0 0 23 25' fill='none' {...props}>
      <Path
        d='M18.3413 8.00952C18.3413 6.15048 17.6105 4.36758 16.3096 3.05304C15.0088 1.7385 13.2444 1 11.4048 1C9.56509 1 7.80075 1.7385 6.4999 3.05304C5.19906 4.36758 4.46825 6.15048 4.46825 8.00952C4.46825 16.1873 1 18.5238 1 18.5238H21.8095C21.8095 18.5238 18.3413 16.1873 18.3413 8.00952Z'
        stroke-width='2'
        fill='currentColor'
        stroke='currentColor'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <Path
        d='M13.4124 22.5234C13.2083 22.8566 12.9154 23.1331 12.563 23.3253C12.2106 23.5175 11.8111 23.6187 11.4044 23.6187C10.9978 23.6187 10.5982 23.5175 10.2458 23.3253C9.89344 23.1331 9.60054 22.8566 9.39648 22.5234'
        stroke-width='2'
        stroke='currentColor'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </Svg>
  )
}
